module.exports = __webpack_public_path__ + "img/mtwapa.fe42af2b.jpg";